import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// Removed auth dependencies for frontend-only version

interface VerifyOTPResponse {
  success: boolean;
  message?: string;
}

const FinalizeSignIn: React.FC = () => {
  const navigate = useNavigate();
  // Removed auth functionality for frontend-only version
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleVerification = async () => {
    setLoading(true);
    setError(null);

    try {
        const email = localStorage.getItem('emailForSignIn');
        if (!email) {
        throw new Error('Email not found. Please try signing in again.');
      }

      const response = await axios.post<VerifyOTPResponse>(`${import.meta.env.VITE_API_URL}/auth/verify-otp`, {
        email,
        otp: window.location.search.split('=')[1] // Get OTP from URL query parameter
      });

      if (response.data.success) {
        localStorage.removeItem('emailForSignIn');
          navigate('/dashboard');
      }
    } catch (error: any) {
      setError(error.response?.data?.message || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
      }
    };

    return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Complete Sign In
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Please click the button below to complete your sign in
          </p>
        </div>

        {error && (
          <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">{error}</h3>
              </div>
            </div>
          </div>
        )}

        <div>
          <button
            onClick={handleVerification}
            disabled={loading}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <span className="flex items-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Verifying...
              </span>
            ) : (
              'Complete Sign In'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalizeSignIn; 